import React, { useEffect } from "react";
import { usePrimaryOrganization } from "../../../../../hooks";
import { useClosedMessageTemplate } from "../../../../../hooks/useTemplates";
import { Callout, CalloutVariant } from "../../../../Callout";
import { useDataRequestProcessingContext } from "../../DataRequestProcessingContext";
import { EmailButton } from "../../../../organisms/EmailButton";
import { Error as RequestsError } from "../../../../../copy/requests";
import { useApiTrigger } from "../../../../../../common/hooks/api";
import { Fmt } from "../../../../../formatters";
import { Api } from "../../../../../../common/service/Api";

export const NotifyConsumer = () => {
  const [org] = usePrimaryOrganization();
  const { request, refreshRequest, setStepCompleted } = useDataRequestProcessingContext();
  const isBatch = !!request?.batch;

  const [template] = useClosedMessageTemplate(org.id, request.id);

  const fullName = Fmt.DataSubject.fmtFullName(request);

  const [contactRequestor, contactRequestorRequest] = useApiTrigger(
    () => Api.dataRequest.contactRequestor(org.id, request.id),
    refreshRequest,
    RequestsError.TransitionProcessing,
  );
  const { lastStep } = useDataRequestProcessingContext();
  const sendAndClose = lastStep && ["NOTIFY_CONSUMER", "SEND_DATA"].includes(request?.state);
  useEffect(() => {
    const isReadyToClose = lastStep && ["NOTIFY_CONSUMER", "SEND_DATA"].includes(request?.state);
    setStepCompleted(!!request.requestorContacted || isBatch || isReadyToClose);
  }, [request, setStepCompleted, isBatch, lastStep]);

  return (
    <>
      {request.requestorContacted && (
        <div className="w-640">
          <Callout variant={CalloutVariant.Green} className="mb-std">
            Done! Message successfully sent to {request.batch ? "consumers" : fullName}. You can now
            close this request.
          </Callout>
        </div>
      )}
      {!request.requestorContacted && (
        <>
          <div className="text-t3 mb-std">
            The message below will be sent to the {request.batch ? "consumers" : "consumer"}.
          </div>
          <Callout variant={CalloutVariant.Gray} className="mb-md">
            <div className="text-t3">
              <p>
                <strong>
                  To:{" "}
                  {request.batch
                    ? `${request.batch.requestCount} recipients`
                    : request.subjectEmailAddress}
                </strong>
              </p>
              <p>
                <strong>
                  Subject: A message about your request{" "}
                  {request.batch ? "[Request ID]" : request.id}
                </strong>
              </p>
              <div
                dangerouslySetInnerHTML={{
                  __html: request.batch
                    ? template?.replace(/Hello(?:\s+[^,<]+)?\s*,/, "Hello [First Name],")
                    : template,
                }}
              />
            </div>
          </Callout>
          {isBatch ? (
            <Callout variant={CalloutVariant.Secondary} className="mb-std">
              Because this is a batch request, emails will be sent automatically in the background.
            </Callout>
          ) : (
            !sendAndClose && (
              <EmailButton
                color="primary"
                variant="contained"
                className="btn-md mb-std"
                loading={contactRequestorRequest.running}
                onClick={contactRequestor}
                disabled={contactRequestorRequest.running}
              >
                Send
              </EmailButton>
            )
          )}
        </>
      )}
    </>
  );
};
